<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiMagnifyMinusOutline } from "@mdi/js"

export default {
  name: "MagnifyMinusOutlineIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiMagnifyMinusOutline,
    }
  }
}
</script>
